import { getCurrentUser } from "@aws-amplify/auth";
import { API_BASE } from "../config/api";

async function readApiError(resp, fallback) {
  try {
    const body = await resp.json();
    return body.error || fallback;
  } catch {
    return fallback;
  }
}

async function withEditorSub(orderData) {
  if (
    orderData &&
    orderData.pick !== undefined &&
    Object.keys(orderData).length === 1
  ) {
    return orderData;
  }

  const currentUser = await getCurrentUser();
  if (!currentUser?.username) {
    throw new Error("You must be logged in to update orders");
  }

  return {
    ...orderData,
    editorSub: currentUser.username
  };
}

// Fetch initial data (customers, products, orders, alerts, etc.)
export async function fetchInitial() {
  const resp = await fetch(`${API_BASE}/initial`);
  if (!resp.ok) throw new Error('Failed to fetch initial data');
  return resp.json();
}

// Customers
export async function updateCustomer(id, customerData) {
  // console.log('Updating customer with ID:', id, 'and data:', customerData);
  const resp = await fetch(`${API_BASE}/customer/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(customerData)
  });
  if (!resp.ok) throw new Error('Failed to update customer');
  return resp.json();
}

export async function updateCustomerRange(id, productIds) {
  const resp = await fetch(`${API_BASE}/customer/${id}/range`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({ productIds })
  });
  if (!resp.ok) throw new Error('Failed to update customer range');
  return resp.json();
}

export async function createCustomer(customerData) {
  console.log('Creating customer with data:', customerData);
  const resp = await fetch(`${API_BASE}/customer`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(customerData)
  });
  if (!resp.ok) throw new Error('Failed to create customer');
  return resp.json();
}

// Orders
export async function createOrder(orderData) {
    console.log('Creating order with data:', orderData);
  const resp = await fetch(`${API_BASE}/order`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(orderData)
  });
  if (!resp.ok) throw new Error('Failed to create order');
  return resp.json();
}

export async function updateOrder(id, orderData) {
  console.log('Updating order with data:', orderData, 'and ID:', id);
  const payload = await withEditorSub(orderData);
  const resp = await fetch(`${API_BASE}/order/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(payload)
  });
  if (!resp.ok) {
    throw new Error(await readApiError(resp, `Failed to update order (${resp.status})`));
  }
  return resp.json();
}

export async function deleteOrder(id) {
  const resp = await fetch(`${API_BASE}/order/${id}`, {
    method: 'DELETE',
  });
  if (!resp.ok) {
    let txt = await resp.text();
    throw new Error(`Failed to delete order (${resp.status}): ${txt}`);
  }
  // if your backend returns 204 No Content, there's nothing to parse
  return;
}

export async function getOrderDetails(orderId) {
  const resp = await fetch(`${API_BASE}/order/${orderId}`);
  if (!resp.ok) throw new Error('Failed to fetch order details');
  return resp.json();
}

// Contacts
export async function createContact(contactData) {
    console.log('Creating contact with data:', contactData);
  const resp = await fetch(`${API_BASE}/contact`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(contactData)
  });
  if (!resp.ok) throw new Error('Failed to create contact');
  return resp.json();
}

export async function updateContact(id, contactData) {
  const resp = await fetch(`${API_BASE}/contact/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(contactData)
  });
  if (!resp.ok) throw new Error('Failed to update contact');
  return resp.json();
}

export async function deleteContact(id) {
  const resp = await fetch(`${API_BASE}/contact/${id}`, {
    method: 'DELETE',
  });
  if (!resp.ok) {
    let txt = await resp.text();
    throw new Error(`Failed to delete contact (${resp.status}): ${txt}`);
  }
  return;
}

// Notes
export async function createNote(noteData) {
  const resp = await fetch(`${API_BASE}/note`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(noteData)
  });
  if (!resp.ok) throw new Error('Failed to create note');
  return resp.json();
}

export async function updateNote(id, noteData) {
  const resp = await fetch(`${API_BASE}/note/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(noteData)
  });
  if (!resp.ok) throw new Error('Failed to update note');
  return resp.json();
}

export async function deleteNote(id) {
  console.log('Deleting note with ID:', id);
  console.log('API_BASE:', API_BASE);
  const resp = await fetch(`${API_BASE}/note/${id}`, {
    method: 'DELETE',
    headers: {'Content-Type': 'application/json'},
  });
  if (!resp.ok) {
    let txt = await resp.text();
    throw new Error(`Failed to delete note (${resp.status}): ${txt}`);
  }
  return;
}

//products
export async function updateProduct(id, productData) {
    console.log('Updating product with ID:', id, 'and data:', productData);
  const resp = await fetch(`${API_BASE}/product/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(productData)
  });
  if (!resp.ok) throw new Error('Failed to update note');
  return resp.json();
}

export async function createProduct(productData) {
    console.log('Creating product with data:', productData);
  const resp = await fetch(`${API_BASE}/product`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(productData)
  });
  if (!resp.ok) throw new Error('Failed to create note');
  return resp.json();
}

//products
export async function updateTerritory(id, territoryData) {
  const resp = await fetch(`${API_BASE}/territory/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(territoryData)
  });
  if (!resp.ok) throw new Error('Failed to update note');
  return resp.json();
}

export async function createTerritory(territoryData) {
  const resp = await fetch(`${API_BASE}/territory`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(territoryData)
  });
  if (!resp.ok) throw new Error('Failed to create note');
  return resp.json();
}

//promotions
export async function updatePromotion(id, promotionsData) {
  console.log('Updating promotion with ID:', id, 'and data:', promotionsData);
  const resp = await fetch(`${API_BASE}/promotion/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(promotionsData)
  });
  if (!resp.ok) throw new Error('Failed to update note');
  return resp.json();
}

export async function createPromotion(promotionsData) {
  const resp = await fetch(`${API_BASE}/promotion`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(promotionsData)
  });
  if (!resp.ok) throw new Error('Failed to create note');
  return resp.json();
}

async function withRequesterSub(payload = {}) {
  const currentUser = await getCurrentUser();
  if (!currentUser?.username) {
    throw new Error("You must be logged in");
  }
  return {
    ...payload,
    requesterSub: currentUser.username
  };
}

// resources
export async function fetchResources(sub, options = {}) {
  const search = new URLSearchParams();
  if (options.archived) search.set("archived", "true");
  const qs = search.toString();
  const resp = await fetch(`${API_BASE}/resources/${sub}${qs ? `?${qs}` : ""}`);
  if (!resp.ok) throw new Error(await readApiError(resp, "Failed to fetch resources"));
  return resp.json();
}

export async function createResource(resourceData) {
  const payload = await withRequesterSub(resourceData);
  const resp = await fetch(`${API_BASE}/resource`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(payload)
  });
  if (!resp.ok) throw new Error(await readApiError(resp, "Failed to create resource"));
  return resp.json();
}

export async function updateResource(id, resourceData) {
  const payload = await withRequesterSub(resourceData);
  const resp = await fetch(`${API_BASE}/resource/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(payload)
  });
  if (!resp.ok) throw new Error(await readApiError(resp, "Failed to update resource"));
  return resp.json();
}

export async function deleteResource(id) {
  const payload = await withRequesterSub({});
  const resp = await fetch(`${API_BASE}/resource/${id}`, {
    method: 'DELETE',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(payload)
  });
  if (!resp.ok) throw new Error(await readApiError(resp, "Failed to delete resource"));
  return resp.json();
}

//users
export async function updateUser(id, userData) {
  console.log('Updating user with ID:', id, 'and data:', userData);
  const resp = await fetch(`${API_BASE}/user/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(userData)
  });
  if (!resp.ok) throw new Error('Failed to update note');
  return resp.json();
}

export async function createUser(userData) {
  const resp = await fetch(`${API_BASE}/user`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(userData)
  });
  if (!resp.ok) throw new Error('Failed to create note');
  return resp.json();
}

//alerts
export async function createAlert(alertData) {
  console.log('Creating alert with data:', alertData);
  const resp = await fetch(`${API_BASE}/alert`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(alertData)
  });
  if (!resp.ok) throw new Error('Failed to create note');
  return resp.json();
}
export async function updateAlert(id, alertData) {
  const resp = await fetch(`${API_BASE}/alert/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(alertData)
  });
  if (!resp.ok) throw new Error('Failed to update note');
  return resp.json();
}

//budgets
export async function createBudget(budgetData) {
  console.log('Creating budget with data:', budgetData);
  const resp = await fetch(`${API_BASE}/budget`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(budgetData)
  });
  if (!resp.ok) throw new Error('Failed to create budget');
  return resp.json();
}
export async function updateBudget(id, budgetData) {
  console.log('Updating budget with ID:', id, 'and data:', budgetData);
  const resp = await fetch(`${API_BASE}/budget/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(budgetData)
  });
  if (!resp.ok) throw new Error('Failed to update budget'); // Changed 'note' to 'budget'
  return resp.json();
}

//settings
export async function updateSetting(settingData) {
  console.log('Updating settings with data:', settingData);
  const resp = await fetch(`${API_BASE}/settings`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(settingData)
  });
  if (!resp.ok) throw new Error('Failed to update settings');
  return resp.json();
}

// Distributions
export async function createDistribution(distributionData) {
  console.log('Creating distribution with data:', distributionData);
  const resp = await fetch(`${API_BASE}/distribution`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(distributionData)
  });
  if (!resp.ok) throw new Error('Failed to create distribution');
  return resp.json();
}

export async function updateDistribution(id, distributionData) {
  console.log('Updating distribution with ID:', id, 'and data:', distributionData);
  const resp = await fetch(`${API_BASE}/distribution/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(distributionData)
  });
  if (!resp.ok) throw new Error('Failed to update distribution');
  return resp.json();
}

// Brands
export async function createBrand(brandData) {
  console.log('Creating brand with data:', brandData);
  const resp = await fetch(`${API_BASE}/brands`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(brandData)
  });
  if (!resp.ok) throw new Error('Failed to create brand');
  return resp.json();
}

export async function updateBrand(id, brandData) {
  console.log('Updating brand with ID:', id, 'and data:', brandData);
  const resp = await fetch(`${API_BASE}/brands/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(brandData)
  });
  if (!resp.ok) throw new Error('Failed to update brand');
  return resp.json();
}

// Units of Measure
export async function createUnitOfMeasure(unitOfMeasureData) {
  console.log('Creating unit of measure with data:', unitOfMeasureData);
  const resp = await fetch(`${API_BASE}/unitofmeasure`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(unitOfMeasureData)
  });
  if (!resp.ok) throw new Error('Failed to create unit of measure');
  return resp.json();
}

export async function updateUnitOfMeasure(id, unitOfMeasureData) {
  console.log('Updating unit of measure with ID:', id, 'and data:', unitOfMeasureData);
  const resp = await fetch(`${API_BASE}/unitofmeasure/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(unitOfMeasureData)
  });
  if (!resp.ok) throw new Error('Failed to update unit of measure');
  return resp.json();
}

// Categories
export async function createCategory(categoryData) {
  console.log('Creating category with data:', categoryData);
  const resp = await fetch(`${API_BASE}/category`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(categoryData)
  });
  if (!resp.ok) throw new Error('Failed to create category');
  return resp.json();
}

export async function updateCategory(id, categoryData) {
  console.log('Updating category with ID:', id, 'and data:', categoryData);
  const resp = await fetch(`${API_BASE}/category/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(categoryData)
  });
  if (!resp.ok) throw new Error('Failed to update category');
  return resp.json();
}

// Banners
export async function createBanner(bannerData) {
  console.log('Creating banner with data:', bannerData);
  const resp = await fetch(`${API_BASE}/banner`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(bannerData)
  });
  if (!resp.ok) throw new Error('Failed to create banner');
  return resp.json();
}

export async function updateBanner(id, bannerData) {
  console.log('Updating banner with ID:', id, 'and data:', bannerData);
  const resp = await fetch(`${API_BASE}/banner/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(bannerData)
  });
  if (!resp.ok) throw new Error('Failed to update banner');
  return resp.json();
}

// Regions
export async function createRegion(regionData) {
  console.log('Creating region with data:', regionData);
  const resp = await fetch(`${API_BASE}/region`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(regionData)
  });
  if (!resp.ok) throw new Error('Failed to create region');
  return resp.json();
}

export async function updateRegion(id, regionData) {
  console.log('Updating region with ID:', id, 'and data:', regionData);
  const resp = await fetch(`${API_BASE}/region/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(regionData)
  });
  if (!resp.ok) throw new Error('Failed to update region');
  return resp.json();
}

// Store Types
export async function createStoreType(storeTypeData) {
  console.log('Creating store type with data:', storeTypeData);
  const resp = await fetch(`${API_BASE}/storetype`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(storeTypeData)
  });
  if (!resp.ok) throw new Error('Failed to create store type');
  return resp.json();
}

export async function updateStoreType(id, storeTypeData) {
  console.log('Updating store type with ID:', id, 'and data:', storeTypeData);
  const resp = await fetch(`${API_BASE}/storetype/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(storeTypeData)
  });
  if (!resp.ok) throw new Error('Failed to update store type');
  return resp.json();
}

// Orders CSV export
export async function exportOrdersCsv(startDate, endDate) {
  const resp = await fetch(`${API_BASE}/orders/export`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ startDate, endDate })
  });

  const disposition = resp.headers.get('Content-Disposition');

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || `Failed to export orders (${resp.status})`);
  }

  const blob = await resp.blob();
  let filename = `orders_${startDate}_${endDate}.csv`;

  if (disposition) {
    const match = disposition.match(/filename\*?=([^;]+)/i);
    if (match && match[1]) {
      const raw = match[1].trim().replace(/^UTF-8''/, '').replace(/"/g, '');
      try {
        filename = decodeURIComponent(raw);
      } catch {
        filename = raw;
      }
    }
  }

  return { blob, filename };
}


// Tasks
export async function createTask(taskData) {
  const resp = await fetch(`${API_BASE}/task`, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(taskData)
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to create task');
  }
  return resp.json();
}

export async function updateTask(id, taskData) {
  const resp = await fetch(`${API_BASE}/task/${id}`, {
    method: 'PUT',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(taskData)
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to update task');
  }
  return resp.json();
}

export async function deleteTask(id) {
  const resp = await fetch(`${API_BASE}/task/${id}`, {
    method: 'DELETE',
  });
  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`Failed to delete task (${resp.status}): ${txt}`);
  }
  // No content returned
 return;

}
